<template>
  <div class="tab_container">
    <div 
      class="tab_item" 
      v-for="item in tabList" 
      :key="item.key"
      :class="{tabActive: currentItem === item.key ? true : false}"
      @click="() => {clickHandle(item)}"
    >
    {{item.name}}</div>
  </div>
</template>

<script>
export default {
  props:['tabList','currentTab'],
  computed:{
    currentItem:{
      get() {
        return this.currentTab
      },
      set(newValue) {
        this.$emit('selectTabHandle',{key:newValue,item:this.item})
      }
    }
  },
  methods:{
    // 数据状态切换
		clickHandle(data) {
      this.item = data
      this.currentItem = data.key
    }
  }
}
</script>

<style lang="less" scoped>
.tab_container{
  width: 100%;
  height: 0.46rem;
  display: flex;
  align-items: center;
  padding: 0 16px;
  .tab_item{
    width:76px;
    height:30px;
    margin-right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight:400;
    color:rgba(153,153,153,1);
    background:rgba(248,248,248,1);
    border-radius:3px;
  }
}

.tabActive{
  background:rgba(255,237,234,1) !important;
  border:1px solid rgba(254,121,34,0.2);
  color: #FE7922 !important;
}
</style>